module.exports = __webpack_public_path__ + "media/ahhh-ngean.17afe8d3.mp3";